import { render } from "./AddCommodityStockDialog.vue?vue&type=template&id=03132c10"
import script from "./AddCommodityStockDialog.vue?vue&type=script&lang=js"
export * from "./AddCommodityStockDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__